import EditEntityModal from '../../modals/EditEntityModal';
import EditPrincipalModal from '../../modals/EditPrincipalModal/EditPrincipalModal';
import DeleteBorrowerEntityToPrincipalLinkModal from '../../modals/DeleteBorrowerEntityToPrincipalLinkModal';
import DeleteBusinessToPrincipalLinkModal from '../../modals/DeleteBusinessToPrincipalLinkModal';
import EditCompanyModal from '../../modals/EditCompanyModal';
import DeleteForeverModal from '../../modals/DeleteForeverModal';
import RecycleBinModal from '../../modals/RecycleBinModal';
import EntityAuditHistoryModal from '../../modals/EntityAuditHistoryModal';
import EditBorrowerEntityToPrincipalLinkModal from '../../modals/EditBorrowerEntityToPrincipalLinkModal';

export const BorrowerModals = () => {
    return (
        <>
            <EditEntityModal />
            <EditPrincipalModal />
            <EditBorrowerEntityToPrincipalLinkModal />
            <DeleteBorrowerEntityToPrincipalLinkModal />
            <DeleteBusinessToPrincipalLinkModal />
            <EditCompanyModal />
            <DeleteForeverModal />
            <RecycleBinModal />
            <EntityAuditHistoryModal />
        </>
    );
};
